import "../../../App.css"
import { useGlobalContext } from "../../../Context/Authentation"
import { useNavigate } from 'react-router-dom';

export default function Search() {
    const navigate = useNavigate();
    const { AllNotesArray, setsearchNoteArray, SearchKeyword, setSearchKeyword } = useGlobalContext();
    var searchArray = [];

    const EnterKeySearch = (e) => {
        if (e.key === "Enter") {
            SearchHandle();
        }
    }
    const SearchHandle = () => {
        searchArray = [];
        if (SearchKeyword) {
            for (var i = 0; i < AllNotesArray.length; i++) {
                if (AllNotesArray[i].title.includes(SearchKeyword)) {
                    searchArray.push(AllNotesArray[i]);
                }
            }
            setsearchNoteArray(searchArray);
            if (window.location.pathname !== "/Home/Note/search") {
                navigate("/Home/Note/search")
            }
        }
    }

    return (
        <div id='SearchBar' className="input-group mb-3 m-auto" style={{ width: "70%", border: "none", outline: "none" }}>
            <input type="text" placeholder="Search Notes here by Title...." className="form-control m-auto"
                onChange={(e) => { setSearchKeyword(e.target.value) }}
                onKeyDown={EnterKeySearch}
                value={SearchKeyword} />
            <span className="input-group-text" style={{ cursor: "pointer" }} id="basic-addon2" onClick={SearchHandle}>Search</span>
        </div>
    )
}
